export const getArraySectionInitialData = <T>(currentData: T[] | undefined, emptyData: T[]) => {
  return currentData?.length ? currentData : emptyData
}
